import { useEffect, useRef, useState } from 'react';
import cls from 'classnames';

import './style.scss';

interface ISimpleToastProps {
  show: boolean;
  setShow: (value: boolean) => void;
  content: string;
}

export default function SimpleToast(props: ISimpleToastProps): JSX.Element {
  const { show, setShow, content } = props;
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  const timer = useRef(0);
  useEffect(() => {
    if (!show) {
      return;
    }

    const newTimer = window.setTimeout(() => {
      setShow(false);
    }, 2150);
    timer.current = newTimer;

    return () => window.clearTimeout(newTimer);
  }, [show, setShow]);

  return (
    <div className={cls('simple-toast', { show, hide: !show && hydrated })}>
      <p>{content || ''}</p>
    </div>
  );
}
